import React from 'react';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faQuestionCircle} from '@fortawesome/free-solid-svg-icons';
import {OverlayTrigger, Tooltip} from 'react-bootstrap';

import './styles.scss';

interface IHelpIconProps {
    id: string;
    placement: (
        'auto' |
        'top' |
        'bottom' |
        'left' |
        'right' |
        'auto-start' |
        'auto-end' |
        'top-start' |
        'top-end' |
        'bottom-start' |
        'bottom-end' |
        'left-start' |
        'left-end' |
        'right-start' |
        'right-end'
        );
    size?: 'xs' | 'sm' | 'lg' | '2x' | '3x' | '5x' | '7x' | '10x' | '1x' | '4x' | '6x' | '8x' | '9x'
    className?: string;
    largeTooltip?: boolean;
}

export const HelpIcon = ({className, children, id, placement, size, largeTooltip}: React.PropsWithChildren<IHelpIconProps>) => {
    const tooltip = (
        <Tooltip id={id} className={`HelpIcon__tooltip${largeTooltip ? '-lg' : ''}`}>{children}</Tooltip>
    );

    return (
        <OverlayTrigger transition={false} placement={placement} overlay={tooltip}>
            {({ref, ...triggerHandler}) => (
                <FontAwesomeIcon
                    {...triggerHandler}
                    forwardedRef={ref ?? undefined}
                    icon={faQuestionCircle}
                    size={size}
                    className={'HelpIcon__icon ' + className ?? ''}
                />
            )}
        </OverlayTrigger>
    );
};

HelpIcon.defaultProps = {
    placement: 'top',
};
